<h1 mat-dialog-title>{{areModelTags()?'Model tags':'Node tag group'}}</h1>
<mat-dialog-content [formGroup]="tagGroupForm" autocomplete="false">
  <mat-divider></mat-divider>
  <br>

    @if (!areModelTags()) {
      <mat-form-field>
        <mat-label>Name</mat-label>
        <input type="text" matInput #nameInput formControlName="name" [errorStateMatcher]="matcher" autocomplete="tag-group-name" id="tag-group-name">
        @if ((tagGroupForm.controls['name'].hasError('minlength') || tagGroupForm.controls['name'].hasError('maxlength')) && !tagGroupForm.controls['name'].hasError('required')) {
          <mat-error>
            Name must be between 5 and 30 characters
          </mat-error>
        }
        @if (tagGroupForm.controls['name'].hasError('required')) {
          <mat-error>
            Name is <strong>required</strong>
          </mat-error>
        }
      </mat-form-field>
      <br>
        <mat-form-field>
          <mat-label>Description</mat-label>
          <input type="text" matInput formControlName="description" [errorStateMatcher]="matcher" autocomplete="tag-group-description" id="tag-group-description">
          @if (tagGroupForm.controls['description'].hasError('maxlength')) {
            <mat-error>
              Description must be less than 50 characters
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Model</mat-label>
          <mat-select formControlName="modelKeys" multiple>
            <mat-option value="all-models">-- All --</mat-option>
            @for (model of getModels(); track model) {
              <mat-option [value]="model._key">{{model.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        }@else {
        <p>Add tags that can be used to filter or categorise models.</p>
      }

      <ng-container formArrayName="tags" class="tags-container">
        @for (tagForm of tags.controls; track tagForm; let i = $index) {
          <div [formGroupName]="i">
            <div [ngClass]="extended?'tag-container-extended':'tag-container'">
                <i class="fa fa-solid fa-tag" [style]="getColourStyleForTag(i)"></i>
                <mat-form-field appearance="fill">
                    <input matInput formControlName="name" placeholder="Tag name">
                </mat-form-field>
                @if (extended) {
                    <mat-form-field appearance="fill">
                        <input matInput formControlName="imageUrl" placeholder="Image URL">
                    </mat-form-field>

                    <img height="60px" [src]="tagForm.value.imageUrl" alt="None"/>
                }
                <button mat-icon-button (click)="removeTag(i)" color="warn">
                    <mat-icon>delete</mat-icon>
                </button>

            </div>
            @if (tagError(i)) {
              <mat-error>
                Tag name is mandatory and must be less than 41 characters
              </mat-error>
            }
          </div>
        }
      </ng-container>

      @if (tags.controls.length < MAX_COLOURS) {
        <section>
          <button mat-mini-fab (click)="addTag()">
            <mat-icon class="add-course-btn">add</mat-icon>
          </button>
          <span style="padding-left:10px;align-self: center;">Add new tag</span>
        </section>
      }
      @if (tags.controls.length >= MAX_COLOURS) {
        <p>{{'Tag limit of ' + MAX_COLOURS + ' reached'}}</p>
      }

      @if (!areModelTags()) {
        <mat-form-field style="padding-top:20px;">
          <mat-label>Type delete to enable delete button</mat-label>
          <input type="text" matInput formControlName="deleteField">
        </mat-form-field>
      }
    </mat-dialog-content>

    <div mat-dialog-actions>
      <button mat-raised-button (click)="onCancelClick()">
        <mat-icon>cancel</mat-icon>
        Cancel
      </button>
      <button mat-raised-button color="primary" cdkFocusInitial (click)="save()" [disabled]="!tagGroupForm.valid">
        <mat-icon>save</mat-icon>
        Save
      </button>
      @if (!areModelTags()) {
        <button mat-raised-button color="warn" cdkFocusInitial (click)="deleteGroup()" [disabled]="deleteDisabled()">
          <mat-icon>delete</mat-icon>
          Delete group
        </button>
      }
    </div>
